import type { InteriorPage } from '../types/content';

export const interiorPages: InteriorPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/cdMDj6KCtQHq3nYqeYWudi/Captura-de-pantalla-2026-09-18-a-la_s_-5.52.06_p.-m..webp',
    caption: 'Hard start after fuel-system service',
    alt: 'Interior page: case study of a hard start after fuel-system service, with complaint, inspection, evidence, repair, verification, and a before-and-after fuel circuit diagram.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8fnn8cjM2oTM2v2irTRDPn/Captura-de-pantalla-2026-09-18-a-la_s_-5.51.35_p.-m..webp',
    caption: 'Injector electrical diagnostics',
    alt: 'Interior page: injector electrical diagnostics, showing the ECM driver circuit, harness, connector, and injector with numbered fault check points.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/i6MV53zCN4shs6zQKTgaYp/Captura-de-pantalla-2026-09-18-a-la_s_-5.50.28_p.-m..webp',
    caption: 'Preliminary fuel-system inspection',
    alt: 'Interior page: preliminary fuel-system inspection checklist with a fuel circuit diagram and component examples.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rCCcNeg79fCxrL6Nj6R7or/Captura-de-pantalla-2026-09-18-a-la_s_-5.50.50_p.-m..webp',
    caption: 'Fuel quality and contamination diagnostics',
    alt: 'Interior page: fuel quality and contamination diagnostics, comparing fuel samples and outlining an inspection sequence.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4qWqoC7gK6EraMGXKrAQzY/Captura-de-pantalla-2026-09-18-a-la_s_-5.51.07_p.-m..webp',
    caption: 'High-pressure pump function and diagnostic role',
    alt: 'Interior page: high-pressure pump function and diagnostic role, with a cutaway diagram and a map of low rail pressure causes.',
  },
];
